import { createBrowserClient } from '@supabase/ssr'
import type { SupabaseClient } from '@supabase/supabase-js'
import { supabaseConfig } from './config'

export function createClient() {
    return createBrowserClient(
        process.env['NEXT_PUBLIC_SUPABASE_URL']!,
        process.env['NEXT_PUBLIC_SUPABASE_ANON_KEY']!,
        supabaseConfig
    )
}

export const supabase = createClient()

// Re-export SupabaseClient type for convenience
export type { SupabaseClient }
